import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./Components/Home";
import PrivacyPage from "./Components/PrivacyPage";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import AboutPage from "./Components/AboutPage";

function App() {
	useEffect(() => {
		AOS.init();
	}, []);
	return (
		<div>
			<Navbar />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/privacy" element={<PrivacyPage />} />
				<Route path="/terms" element={<PrivacyPage />} />
				<Route path="/about-us" element={<AboutPage />} />
			</Routes>
			<Footer />
		</div>
	);
}

export default App;
